// extracted by mini-css-extract-plugin
module.exports = {"wrapBodyModal":"RemoteOutputs_wrapBodyModal__3txd_","wrapForMobile":"RemoteOutputs_wrapForMobile__wmW4f","table_mobile":"RemoteOutputs_table_mobile__jfHJ6"};